import type { JSX } from 'react';
import { Construction } from 'lucide-react';

interface StubInfo {
  title: string;
  desc: string;
  phase: string;
}

const STUBS: Record<string, StubInfo> = {
  '/finance/reconciliation': {
    title: 'Reconciliation',
    desc: 'Financial reconciliation across all accounts.',
    phase: 'Post-launch',
  },
  '/finance/expenses': {
    title: 'Expenses',
    desc: 'Track operational expenses: shipping, prep, storage, subscriptions.',
    phase: 'Post-launch',
  },
  '/finance/payroll': {
    title: 'Payroll',
    desc: 'Payroll tracking for VA and warehouse staff.',
    phase: 'Post-launch',
  },
  '/finance/review': {
    title: 'Review',
    desc: 'Financial review queue for admin approval.',
    phase: 'Post-launch',
  },
};

interface FinanceStubProps {
  path: string;
}

export default function FinanceStub({ path }: FinanceStubProps): JSX.Element {
  const info: StubInfo = STUBS[path] || {
    title: 'Finance',
    desc: 'Coming soon.',
    phase: 'Post-launch',
  };

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 text-center p-8">
      <div className="w-16 h-16 rounded-xl bg-surface-2 border border-border flex items-center justify-center">
        <Construction size={32} className="text-ink-muted" />
      </div>
      <div className="max-w-sm">
        <h2 className="text-base font-semibold text-ink-bright">{info.title}</h2>
        <p className="text-xs text-ink-muted mt-2 leading-relaxed">{info.desc}</p>
        <span className="inline-block mt-3 px-2 py-0.5 rounded text-2xs font-medium bg-accent/10 text-accent">
          {info.phase === 'Post-launch' ? 'Post-launch' : `Coming in ${info.phase}`}
        </span>
      </div>
    </div>
  );
}
